import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo, apiSetDeflected } from "utils/API/TrxNowAPI";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
import "./BWCMemberInformationForm.scss";
import { devLog } from "utils/devLog";

const policyMap = new Map();
function BWCMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.memberNumber);
  const [memberNumber, setMemberNumber] = useState(props.currState.MemberLookup.memberNumber);

  const [firstName, setFirstName] = useState(props.currState.MemberLookup.firstName);
  const [lastName, setLastName] = useState(props.currState.MemberLookup.lastName);
  const [phoneNumber, setPhoneNumber] = useState(props.currState.MemberLookup.phoneNumber);

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType);
  const [contractData, setContractData] = useState(undefined);

  const [memberArray, setMemberArray] = useState([]);
  const [selectedMember, setSelectedMember] = useState("");
  const [contacts, setContacts] = useState([]);
  const [account, setAccount] = useState(undefined);
  const [selectedContact, setSelectedContact] = useState(null);
  const [partnerCode, setPartnerCode] = useState(props.currState.localGroup);

  // useEffect(() => {
  //   // setPhoneNumber("");
  //   onSubmit();
  // }, []);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
    }
  };
  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();

    if (policyMap.has(searchValue)) {
      setContractData(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        searchType: searchType,
        memberNumber: memberNumber,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        partnerCode: partnerCode,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        if (typeof json.data.accountInfo === "object") {
          // setMemberArray(json.data.memberInfo);
          // setMemberNumber(json.data.memberInfo.memberNumber);

          if (!json.data.error) {
            // setContractData(json.data.memberInfo);
            setContacts(json.data.contactList);
            setAccount(json.data.accountInfo);
            // onMemberInfo(json.data.accountInfo, json.data.contactList);
            onLoad(true);
          } else {
            setError(json.data.error.message);
            setContacts([]);
            setAccount(undefined);
            onLoad(false);
          }
        } else if (typeof json.data.error === "object") {
          setError(json.data.error.message);
          setContacts([]);
          setAccount(undefined);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setError(t("BWC.PolicyInformation.UnableToFindMember"));
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
      })

      //Lookup: Failed
      .catch((e) => {
        devLog("error", e);
        setLoading(false);
        setError(t("BWC.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };
  const onUserBack = (e) => {
    e.preventDefault();
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  // const onSelect = (contact) => {
  //   devLog("onSelect", contact);
  //   if (typeof contact === "object" && typeof props.onSelect === "function") {
  //     props.onSelect(account, contact);
  //     setSelectedMember(contact);
  //   }
  // };

  // const onMemberInfo = (memberInfo, contactInfo) => {
  //   if (typeof props.onMemberInfo === "function") {
  //     // props.onSelect(memberInfo, contactInfo);
  //     devLog("memberInfo: " + memberInfo);
  //   }
  // };

  //select Contact function, set selectContact to contactInfo => input
  //
  const onSelect = (sc) => {
    // devLog("selected Contact: ", sc);
    setSelectedContact(sc);
    // onMemberInfo(account, sc);

    if (typeof props.onSelect === "function") {
      props.onSelect(account, sc);
    }

    if (sc === undefined) {
      // devLog("selected undefined Contact: ", props.context.state.FirstName + " " + props.context.state.LastName);
      setFirstName(props.context.state.FirstName);
      setLastName(props.context.state.LastName);
    } else {
      setFirstName(sc.firstName);
      setLastName(sc.lastName);
      // devLog("selected defined Contact: ", sc.firstName + " " + sc.lastName);
    }
  };

  useEffect(() => {
    // devLog(props);
    onSubmit();
    checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
    // devLog("run useEffect", checkDuplicateName);
  }, []);

  useEffect(() => {
    checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
    // devLog("run useEffect", checkDuplicateName);
  }, [contacts]);

  const [checkDuplicateName, setCheckDuplicateName] = useState(false);

  const checkDuplicateContact = (firstName, lastName) => {
    contacts.map((con, index) => {
      if (
        con.firstName.toUpperCase().trim() === firstName.toUpperCase().trim() &&
        con.lastName.toUpperCase().trim() === lastName.toUpperCase().trim()
      ) {
        // devLog(firstName, lastName);
        setCheckDuplicateName(true);
      }
      return checkDuplicateContact;
    });
  };
  return (
    <>
      <div className="formContainer">
        {account ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.ContractInformationHeader2")}</h4>
              <hr />
              {/*Member Number*/}
              <div className="policy-info-line">
                <b>{t("BWC.PolicyInformation.ConfirmCustomerMemberNumber")}:</b> {account.memberNumber}
              </div>
            </div>
            {/*First & Last Name*/}
            <div className="vehicleHeader">
              <h4 className="slim">{t("BWC.PolicyInformation.MemberInformationHeader2")}</h4>
            </div>
            <div className="vehicle-list-container">
              <>
                {contacts.map((cont, index) => {
                  return (
                    <div
                      key={index}
                      value={cont}
                      className={`vehicle-list-item ${selectedMember === cont ? "selected" : ""}`}
                      onClick={(e) => {
                        onSelect(cont);
                      }}
                    >
                      <div value={cont} className="vehicle-list-item-col-1">
                        <h5 value={cont}>
                          {cont.firstName} {cont.lastName}
                        </h5>
                      </div>
                      <input
                        className="vehicleSelector"
                        type="radio"
                        name="policy-vehicle"
                        checked={selectedMember === cont ? "selected" : ""}
                        onChange={() => setSelectedMember(cont)}
                        required
                      />
                    </div>
                  );
                })}

                {!checkDuplicateName ? (
                  <>
                    <div className="vehicleHeader">
                      <h4 className="slim">{t("description.AddContactInformationHeader")}</h4>
                    </div>
                    <div className="vehicle-list-container">
                      <>
                        <div
                          className={`vehicle-list-item ${selectedMember === undefined}`}
                          onClick={(e) => {
                            onSelect(undefined);
                          }}
                        >
                          <div className="vehicle-list-item-col-1">
                            <h5>
                              {props.currState.FirstName} {props.currState.LastName}
                            </h5>
                          </div>
                          <input
                            className="vehicleSelector"
                            type="radio"
                            name="policy-vehicle"
                            checked={selectedMember === undefined ? "selected" : ""}
                            onChange={() => setSelectedMember(undefined)}
                            required
                          />
                        </div>
                      </>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </>
            </div>
          </div>
        ) : (
          <></>
        )}{" "}
      </div>
      {error ? (
        <div className="errorSection">
          <b className="error">{error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              {t("description.TryAgain")}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleBWC`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}

export default BWCMemberInformationForm;
